import { render, staticRenderFns } from "./stationeryRecord-topbar.vue?vue&type=template&id=31a4a5d2&scoped=true"
import script from "./stationeryRecord-topbar.vue?vue&type=script&lang=js"
export * from "./stationeryRecord-topbar.vue?vue&type=script&lang=js"
import style0 from "./stationeryRecord-topbar.vue?vue&type=style&index=0&id=31a4a5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a4a5d2",
  null
  
)

export default component.exports